/* Monchys: up-sell, vela en ficha y antojos en carrito. Se apagan en Configuración del tema > Ventas (Monchys). */
(function(){
  if (window.__monchysVentas) return; window.__monchysVentas = true;
  var nativeFetch = window.fetch;
  function money(c){ var v = c / 100; return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); }
  function info(title){
    var t = String(title || '');
    var unit = /rebanad/i.test(t) ? 'rebanadas' : 'personas';
    if (/individual/i.test(t)) return { n: 1, unit: unit, name: t.split('(')[0].trim() };
    var nums = (t.match(/\d+/g) || []).map(Number);
    if (!nums.length) return null;
    return { n: Math.min.apply(null, nums), unit: unit, name: t.split('(')[0].trim() };
  }

  /* ---------- Up-sell (todos los productos) ---------- */
  function upRoot(){ return document.querySelector('[data-mu-up]'); }
  function variants(){
    var el = document.querySelector('[data-mu-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  function form(){ var r = upRoot(); return (r && r.closest('form')) || document.querySelector('form[action*="/cart/add"]'); }
  function currentId(){ var f = form(); var inp = f && f.querySelector('[name="id"]'); return inp ? Number(inp.value) : null; }
  function placeUp(){
    var root = upRoot(); if (!root || root.__placed) return;
    var picker = document.querySelector('.prod__option--button, variant-picker, .variant-picker');
    if (picker && picker.parentElement) { picker.insertAdjacentElement('afterend', root); }
    root.__placed = true;
  }
  function norm(s){ return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\b3 leches\b/g, 'tres leches').replace(/\s+/g, ' ').trim(); }
  function show(html, btnText, action){
    var root = upRoot();
    root.querySelector('[data-mu-up-text]').innerHTML = html;
    var btn = root.querySelector('[data-mu-up-btn]');
    btn.textContent = btnText; btn.__action = action;
    root.hidden = false;
  }
  function hide(){ var r = upRoot(); if (r) r.hidden = true; }
  var bigCache = {};
  function renderUp(){
    var root = upRoot(); if (!root) return;
    placeUp();
    var vs = variants(), id = currentId();
    var cur = vs.filter(function(v){ return v.id === id; })[0] || vs[0];
    if (!cur) { hide(); return; }
    var ci = info(cur.title);
    if (vs.length > 1 && ci) {
      var bigger = vs.map(function(v){ return { v: v, i: info(v.title) }; })
        .filter(function(x){ return x.i && x.v.available && x.i.n > ci.n; })
        .sort(function(a, b){ return a.i.n - b.i.n; });
      var nx = bigger[0];
      if (nx && nx.v.price / nx.i.n < cur.price / ci.n) {
        var us = nx.i.unit === 'rebanadas' ? 'rebanada' : 'persona';
        var vb = nx.i.unit === 'rebanadas' ? 'rinde' : 'alcanza para';
        var pre = ci.n === 1 ? '¿Vas a compartir?' : '¿Son más de ' + ci.n + '?';
        show(pre + ' El <b>' + nx.i.name + '</b> ' + vb + ' ' + nx.i.n + ' ' + nx.i.unit + ': <b>' + money(Math.round(nx.v.price / nx.i.n / 100) * 100) + ' por ' + us + '</b>.',
          'Cambiar a ' + nx.i.name + ' · ' + money(nx.v.price), { option: nx.v.option1 });
        return;
      }
    }
    if (vs.length > 1) {
      var up = vs.filter(function(v){ return v.available && v.price > cur.price; }).sort(function(a, b){ return a.price - b.price; })[0];
      if (up) {
        var nm = String(up.title).split('(')[0].trim();
        show('¿Se te antoja más? El <b>' + nm + '</b> por solo <b>' + money(up.price - cur.price) + ' más</b>.', 'Cambiar a ' + nm + ' · ' + money(up.price), { option: up.option1 });
        return;
      }
    }
    var title = root.getAttribute('data-title') || '';
    var m = /^(pequito|rebanada|mini)\s+(.+)$/i.exec(title.trim());
    if (m) { bigVersion(title, m[2]); return; }
    if (cur.price <= 6000) {
      show('Se disfrutan mejor en compañía: <b>llévate 3 por ' + money(cur.price * 3) + '</b>.', 'Llevar 3', { qty: 3 });
      return;
    }
    if (cur.price <= 12000) {
      show('¿Invitas a alguien? <b>Llévate 2 por ' + money(cur.price * 2) + '</b>.', 'Llevar 2', { qty: 2 });
      return;
    }
    hide();
  }
  function bigVersion(title, flavor){
    var key = norm(flavor);
    if (bigCache[key] === null) { hide(); return; }
    if (bigCache[key]) { var b = bigCache[key]; show(b.html, b.btn, b.action); return; }
    hide();
    var handle = upRoot().getAttribute('data-handle');
    nativeFetch('/search/suggest.json?q=' + encodeURIComponent(flavor) + '&resources[type]=product&resources[limit]=10')
      .then(function(r){ return r.json(); })
      .then(function(j){
        var list = (j.resources && j.resources.results && j.resources.results.products) || [];
        var cand = list.filter(function(p){ var t = norm(p.title); return p.handle !== handle && t.indexOf(key) > -1 && !/^(pequito|rebanada|mini)\b/.test(t); })[0];
        if (!cand) { bigCache[key] = null; return; }
        return nativeFetch('/products/' + cand.handle + '.js').then(function(r){ return r.json(); }).then(function(p){
          var opts = p.variants.map(function(v){ return { v: v, i: info(v.title) }; }).filter(function(x){ return x.v.available && x.i && x.i.n > 2 && !/pequito|individual/i.test(x.v.title); }).sort(function(a, b){ return a.i.n - b.i.n; });
          var pick = opts[0], html, btn, url;
          if (pick) {
            var us = pick.i.unit === 'rebanadas' ? 'rebanada' : 'persona';
            html = '¿Vas a compartir? El <b>' + p.title + ' ' + pick.i.name + '</b> ' + (pick.i.unit === 'rebanadas' ? 'rinde ' : 'alcanza para ') + pick.i.n + ' ' + pick.i.unit + ': <b>' + money(Math.round(pick.v.price / pick.i.n / 100) * 100) + ' por ' + us + '</b>.';
            btn = 'Ver ' + p.title + ' · ' + money(pick.v.price); url = '/products/' + p.handle + '?variant=' + pick.v.id;
          } else {
            var v0 = p.variants.filter(function(v){ return v.available; }).sort(function(a, b){ return b.price - a.price; })[0];
            if (!v0) { bigCache[key] = null; return; }
            html = '¿Vas a compartir? Llévate el <b>' + p.title + '</b> completo.'; btn = 'Ver ' + p.title + ' · ' + money(v0.price); url = '/products/' + p.handle + '?variant=' + v0.id;
          }
          bigCache[key] = { html: html, btn: btn, action: { url: url } };
          show(html, btn, { url: url });
        });
      })
      .catch(function(){ bigCache[key] = null; });
  }
  function setQty(n){
    var f = form(); var q = (f && f.querySelector('[name="quantity"]')) || document.querySelector('input[name="quantity"]');
    if (!q) return;
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(q, String(n)); q.dispatchEvent(new Event('input', { bubbles: true })); q.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function selectOption(val){
    var inputs = document.querySelectorAll('input[type="radio"]');
    for (var k = 0; k < inputs.length; k++) {
      if (inputs[k].value === val) {
        var lab = inputs[k].id && document.querySelector('label[for="' + inputs[k].id + '"]');
        (lab || inputs[k]).click();
        return true;
      }
    }
    var labs = document.querySelectorAll('.product-option-item, [data-option-value]');
    for (var m = 0; m < labs.length; m++) {
      if (labs[m].textContent.trim() === val || labs[m].getAttribute('data-option-value') === val) { labs[m].click(); return true; }
    }
    var sel = document.querySelectorAll('select');
    for (var s = 0; s < sel.length; s++) { for (var o = 0; o < sel[s].options.length; o++) { if (sel[s].options[o].value === val) { sel[s].value = val; sel[s].dispatchEvent(new Event('change', { bubbles: true })); return true; } } }
    return false;
  }

  /* ---------- Vela en ficha: se agrega junto con el producto ---------- */
  window.fetch = function(input, opts){
    try {
      var url = String(input && input.url || input);
      var vela = document.querySelector('[data-mu-vela-check]');
      if (vela && vela.checked && /\/cart\/add/.test(url) && !(opts && opts.__mu)) {
        var vid = Number(vela.closest('[data-mu-vela]').getAttribute('data-variant'));
        var self = this, args = arguments;
        vela.checked = false;
        return nativeFetch('/cart/add.js', { method: 'POST', __mu: true, headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
          .catch(function(){})
          .then(function(){ return nativeFetch.apply(self, args); });
      }
    } catch (e) {}
    return nativeFetch.apply(this, arguments);
  };

  /* ---------- Antojos en carrito ---------- */
  function refreshDrawer(){
    var C = window.MinimogTheme && window.MinimogTheme.Cart;
    if (!C || !C.renderNewCart) { window.location.href = '/cart'; return Promise.resolve(); }
    return Promise.resolve(C.refreshCart && C.refreshCart())
      .then(function(){ return C.renderNewCart(); })
      .then(function(){ try { C.updateCartCount && C.updateCartCount(C.cart); } catch (e) {} try { window.MinimogEvents && MinimogEvents.emit('ON_CART_UPDATE', C.cart); } catch (e) {} });
  }
  document.addEventListener('click', function(e){
    var up = e.target.closest && e.target.closest('[data-mu-up-btn]');
    if (up) { e.preventDefault(); var a = up.__action || {}; if (a.option) { selectOption(a.option); setTimeout(renderUp, 150); } else if (a.qty) { setQty(a.qty); up.textContent = '¡Listo! ' + a.qty + ' en tu pedido'; } else if (a.url) { window.location.href = a.url; } return; }
    var add = e.target.closest && e.target.closest('[data-ma-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true; add.textContent = '…';
      nativeFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-ma-add')), quantity: 1 }] }) })
        .then(function(){ return refreshDrawer(); })
        .catch(function(){ add.disabled = false; add.textContent = '+'; });
      return;
    }
    if (e.target.closest && e.target.closest('.product-option-item, variant-picker, .prod__option, [data-option-value]')) setTimeout(renderUp, 120);
  });
  document.addEventListener('change', function(e){
    if (e.target.closest && e.target.closest('.prod__option, variant-picker, select')) setTimeout(renderUp, 120);
  });
  function init(){ renderUp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
